import React from 'react'
import Card from '../components/Card'

export default function Admin() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">Admin panel</h2>
        <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12}}>
          <Card><div style={{fontWeight:700}}>New bookkeeper applications</div><div className="kv" style={{marginTop:8}}>3 pending</div><div style={{marginTop:10}}><button className="btn ghost">Review</button></div></Card>
          <Card><div style={{fontWeight:700}}>Active users</div><div className="kv" style={{marginTop:8}}>1,230</div><div style={{marginTop:10}}><button className="btn ghost">View users</button></div></Card>
        </div>
      </section>
    </div>
  )
}
